/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody } from '../../../components/Modais/styles';
import useStore from '../../../services/hooks/useStore';
import { TanqueInfo } from '../../../components/TanqueInfo';
import { observer, useLocalStore } from 'mobx-react-lite';
import Formatter from '../../../services/Formatter';
import { apiV2 } from '../../../services/utils';
import { TextField, Tooltip } from '@material-ui/core';

type Props = ModalProps & {
  onItemClick(tanque: Tanque | null): void;
  selecionadoId: number;
};

// baseado no SelecionarTanque.tsx
const SelecionarTanqueUnico: React.FC<Props> = ({ open, handleClose, onItemClick, selecionadoId }) => {
  const state = useLocalStore(() => ({
    sync: false,
  }));
  const store = useStore();
  const [codigo, setCodigo] = useState<string>('');
  const [tanques, setTanques] = useState<Tanque[]>([] as Tanque[]);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    async function searchTanque() {
      store.toggleLoader();
      await apiV2
        .get('/tanque/modals/', {
          params: {
            propriedade: store.propriedade!.id,
            nome: codigo,
          },
        })
        .then((res) => {
          setTanques(res.data.results);
        });

      state.sync = true;
      store.toggleLoader();
    }

    searchTanque();
  }, [codigo]);

  const TanquesDisponiveis: React.FC = () => (
    <>
      {tanques?.map((tanque) => {
        if (tanque.estoque) {
          const selecionado = tanque.id === selecionadoId;
          return (
            <TanqueInfo
              selected={selecionado}
              onClick={() => {
                onItemClick(selecionado ? null : tanque);
                handleClose();
              }}
              key={tanque.uuid}
            >
              <p className="left">{tanque.nome || tanque.codigo}</p>
              <p className="right">
                {tanque.lotes.length > 0 ? (
                  <Tooltip
                    title={tanque.lotes.map((lote: any) => {
                      return `${lote.codigo || lote.nome}, `;
                    })}
                  >
                    <span>{tanque.lotes[0].codigo + '...'}</span>
                  </Tooltip>
                ) : (
                  ''
                )}{' '}
                ({Formatter.formatNumber(0, tanque.estoque)})
              </p>
              <b className="left" style={{ color: '#00C853' }}>
                {Formatter.formatNumber(3, tanque.biomassa)} Kg
              </b>
              <p className="right" style={{ color: '#00C853' }}>
                {tanque.lotes?.length > 0 ? tanque.lotes[0].fase_lote.nome : ''}
              </p>
            </TanqueInfo>
          );
        } else {
          return null;
        }
      })}
    </>
  );

  return (
    <Modal open={open} onClose={handleClose}>
      <ModalHeader>Selecione um Tanque</ModalHeader>
      <ModalBody>
        <div
          style={{ color: '#707070', width: '100%', padding: '10px', display: 'flex', justifyContent: 'space-between' }}
        >
          <TextField
            label="Pesquisa Pelo Nome"
            value={codigo}
            onChange={(e) => {
              setCodigo(e.target.value);
            }}
          />
        </div>
        <TanquesDisponiveis />
      </ModalBody>
    </Modal>
  );
};

export default observer(SelecionarTanqueUnico);
